import React from 'react';
import { Redirect } from 'react-router-dom';

import getCarrier, { getPrettyCarrier } from '../../helpers/getCarrier';
import ExpireSubscriptionForm from '../../components/ExpireSubscriptionForm/ExpireSubscriptionForm';
import Spinner from 'components/Spinner';
import expiryTypes from 'constants/expiryTypes';

let ExpireSubscription = ({
  onSubmit,
  submitStatus,
  submitSucceeded,
  onSuccessRedirectUrl,
  subId,
  sub,
  isAdmin,
  isReseller,
  loggedInUser,
  showPin,
  showBypass,
  showProration,
  simoExpiryTypeOptions,
}) => {
  if (!loggedInUser || !sub) {
    return null;
  }

  if (submitSucceeded) {
    return <Redirect to={onSuccessRedirectUrl(subId)} />;
  }
  if (!isAdmin && !(isReseller && loggedInUser.id === sub.created_by)) {
    return <Redirect to={onSuccessRedirectUrl(subId)} />;
  }

  const types = simoExpiryTypeOptions || expiryTypes;

  const prettyCarrier = getPrettyCarrier(sub);
  const initialValues = { expiry_type: types?.[0]?.[0] || '' };
  if (showPin) {
    initialValues.pin = sub && sub.pin;
  }

  return (
    <div>
      <h1>Expire {prettyCarrier} Subscription</h1>
      <ExpireSubscriptionForm
        initialValues={initialValues}
        onSubmit={onSubmit}
        types={types}
        carrier={getCarrier(sub)}
        showBypass={showBypass}
        showProration={showProration}
        showPin={showPin}
      />
      <Spinner showLoader={submitStatus === 'PENDING'} />
    </div>
  );
};

export default ExpireSubscription;
